























































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import { FullUser } from '@front-app/services/UserApi/UserModel';
import { SearchOption } from '@front-app/components/search/useSearch';
import SearchOrganizations from '@front-app/modules/organization/components/SearchOrganizations.vue';
import TrAddress from '@front-app/components/TrAddress.vue';
import { FocusableElement } from '@front-app/hooks/useAsyncModal';
import { PartialOrganization } from '@front-app/services/OrganizationsApi/OrganizationModel';
import { OrganizationsStore } from '@front-app/store/singletons/Organizations';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		SearchOrganizations,
		TrAddress,
		SuccessCard,
		ErrorCard,
	},
	props: {
		user: {
			type: Object as PropType<FullUser>,
			required: true,
		},
	},
	setup(props) {
		const {
			allPartial: organizations,
			isLoadingAllPartial: isLoading,
		} = OrganizationsStore;

		const {
			track,
			clear,
			isSuccess,
			isError,
		} = useAsyncStatus();

		const selectOrganization = async (result: SearchOption<PartialOrganization>, returnTo: FocusableElement) => {
			const currentOccupation = {
				employer: {
					id: result.original.id,
				},
			};
			await track(CurrentUserStore.actions.update({ currentOccupation }));
			returnTo.focus();
			clear(4000);
		};
		const currentLogoSrc = computed(() => {
			const { logoSrc } = props.user.currentOccupation.employer;
			// Extra variable is needed here, or else the env var is not properly
			// interpolated for some reason 🤷‍♀️
			const baseUrl = process.env.VUE_APP_TRAPP_PUBLIC_URL;
			return logoSrc ? `${baseUrl}${logoSrc}.png` : '';
		});

		return {
			currentLogoSrc,
			// Entire partial organization list
			isLoading,
			organizations,
			selectOrganization,
			// Status
			isSuccess,
			isError,
		};
	},
});
